'use strict';

var Data = require("../data.js");
var List = require("bs-platform/lib/js/list.js");
var Util = require("../layouts/util.js");
var $$Array = require("bs-platform/lib/js/array.js");
var React = require("react");
var Gatsby = require("../gatsby.js");
var DateFns = require("bs-date-fns/src/DateFns.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SpeakerCard = require("../components/speakerCard.js");
var ScheduleModuleScss = require("./schedule.module.scss");

var talkSlug = Data.Speaker[/* talkSlug */0];

var component = ReasonReact.statelessComponent("Schedule");

function toTimeStr(fromTime, toTime) {
  if (toTime) {
    return Util.toHHMM(fromTime) + (" – " + Util.toHHMM(toTime[0]));
  } else {
    return Util.toHHMM(fromTime) + " – ∞";
  }
}

function toDurationStr(fromTime, toTime) {
  var format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
  if (toTime) {
    return DateFns.format(format, fromTime) + ("/" + DateFns.format(format, toTime[0]));
  } else {
    return DateFns.format(format, fromTime);
  }
}

function miscRow(fromTime, toTime, description) {
  return /* array */[
          React.createElement("dt", {
                className: ScheduleModuleScss.entryTime
              }, React.createElement("time", {
                    dateTime: toDurationStr(fromTime, toTime)
                  }, Util.s(toTimeStr(fromTime, toTime)))),
          React.createElement("dd", {
                className: ScheduleModuleScss.entryDescription
              }, Util.s(description))
        ];
}

function talkRow(fromTime, toTime, speaker) {
  var match = speaker[/* talk */4];
  var tmp;
  if (match) {
    var talk = match[0];
    var id = Data.Speaker[/* talkSlug */0](talk);
    tmp = React.createElement("section", {
          className: ScheduleModuleScss.talkDetails,
          id: id
        }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/speakers/#" + Data.Speaker[/* speakerAnchor */1](speaker), /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, SpeakerCard.make(speaker, /* Some */[true], /* array */[]))])), React.createElement("h3", {
              className: ScheduleModuleScss.talkTitle
            }, Util.s(talk[/* title */0]), Util.s(" "), React.createElement("a", {
                  title: talk[/* title */0],
                  href: "#" + id
                }, Util.s("#"))), Util.md(talk[/* abstract */1]));
  } else {
    tmp = null;
  }
  return /* array */[
          React.createElement("dt", {
                className: ScheduleModuleScss.talkTime
              }, React.createElement("time", {
                    dateTime: toDurationStr(fromTime, toTime)
                  }, Util.s(toTimeStr(fromTime, toTime)))),
          React.createElement("dd", {
                className: ScheduleModuleScss.talkDescription
              }, tmp)
        ];
}

function workshopRow(fromTime, toTime, speakers) {
  var renderSpeaker = function (speaker) {
    return ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/speakers/#" + Data.Speaker[/* speakerAnchor */1](speaker), /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, SpeakerCard.make(speaker, /* Some */[true], /* array */[]))]));
  };
  return /* array */[
          React.createElement("dt", {
                className: ScheduleModuleScss.talkTime
              }, React.createElement("time", {
                    dateTime: toDurationStr(fromTime, toTime)
                  }, Util.s(toTimeStr(fromTime, toTime)))),
          React.createElement("dd", {
                className: ScheduleModuleScss.talkDescription
              }, React.createElement("section", {
                    className: ScheduleModuleScss.talkDetails
                  }, React.createElement("h3", {
                        className: ScheduleModuleScss.talkTitle
                      }, Util.s("Workshop")), React.createElement("p", undefined, Util.s("An optional workshop to make every beginner and intermediate attendee familiar with the language, the BuckleScript platform as well as ReasonReact.")), $$Array.of_list(List.map(renderSpeaker, speakers))))
        ];
}

function openEndRow(fromTime, toTime, description) {
  return /* array */[
          React.createElement("dt", {
                className: ScheduleModuleScss.entryTime
              }, React.createElement("time", {
                    dateTime: toDurationStr(fromTime, /* None */0)
                  }, Util.s(toTimeStr(fromTime, toTime)))),
          React.createElement("dd", {
                className: ScheduleModuleScss.entryDescription
              }, Util.s(description))
        ];
}

function createRow(param) {
  var toTime = param[/* toTime */2];
  var fromTime = param[/* fromTime */1];
  var task = param[/* task */0];
  switch (task.tag | 0) {
    case 0 : 
        return talkRow(fromTime, toTime, task[0]);
    case 1 : 
    case 2 : 
        return miscRow(fromTime, toTime, task[0]);
    case 3 : 
        return workshopRow(fromTime, toTime, task[0]);
    case 4 : 
        return openEndRow(fromTime, toTime, task[0]);
    
  }
}

function make() {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("div", undefined, React.createElement("h1", undefined, Util.s("Schedule")), React.createElement("h2", undefined, React.createElement("time", {
                                  dateTime: "2018-05-11"
                                }, Util.s("11"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Friday at "), ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/attendees/#workshop-and-hackathon-venue", /* None */0, /* None */0, /* None */0, /* array */[Util.s("ImpactHub")])))), React.createElement("dl", {
                              className: ScheduleModuleScss.entries
                            }, $$Array.of_list(List.map(createRow, Data.Timetable[/* day1Timetable */8]))), React.createElement("h2", {
                              id: "day2"
                            }, React.createElement("time", {
                                  dateTime: "2018-05-12"
                                }, Util.s("12"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Saturday at "), ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/attendees/#conference-venue", /* None */0, /* None */0, /* None */0, /* array */[Util.s("TU Wien Kuppelsaal")])))), React.createElement("dl", {
                              className: ScheduleModuleScss.entries
                            }, $$Array.of_list(List.map(createRow, Data.Timetable[/* day2Timetable */9]))), React.createElement("h2", {
                              id: "day3"
                            }, React.createElement("time", {
                                  dateTime: "2018-05-13"
                                }, Util.s("13"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Sunday at "), ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/attendees/#workshop-and-hackathon-venue", /* None */0, /* None */0, /* None */0, /* array */[Util.s("ImpactHub")])))), React.createElement("main", undefined, React.createElement("dl", {
                                  className: ScheduleModuleScss.entries
                                }, React.createElement("dt", {
                                      className: ScheduleModuleScss.entryTime
                                    }, React.createElement("time", undefined, Util.s("9:00 - 10:00"))), React.createElement("dd", {
                                      className: ScheduleModuleScss.entryDescription
                                    }, Util.s("Doors open & forming Teams for the Hackathon")), React.createElement("dt", {
                                      className: ScheduleModuleScss.talkTime
                                    }, React.createElement("time", undefined, Util.s("10:00 - 13:00"))), React.createElement("dd", {
                                      className: ScheduleModuleScss.talkDescription
                                    }, Util.md("\nChoose between:\n\n1. **Open Mic Session** – everyone can come and give a talk. Speakers can opt-in to be recorded and their talk published by our ReasonConf channel.\n2. **Hackathon** – team up with others or work alone on your project of choice\n3. **Vienna Tour** – explore the city center with one of our local volunteers\n            ")), React.createElement("dt", {
                                      className: ScheduleModuleScss.entryTime
                                    }, React.createElement("time", undefined, Util.s("13:00 - 14:00"))), React.createElement("dd", {
                                      className: ScheduleModuleScss.entryDescription
                                    }, Util.s("Lunch")), React.createElement("dt", {
                                      className: ScheduleModuleScss.talkTime
                                    }, React.createElement("time", undefined, Util.s("14:00 - 17:30"))), React.createElement("dd", {
                                      className: ScheduleModuleScss.talkDescription
                                    }, Util.md("\nChoose between:\n\n1. **Hackathon** – team up with others or work alone on your project of choice\n2. **Vienna Tour** – explore the city center with one of our local volunteers\n            ")), React.createElement("dt", {
                                      className: ScheduleModuleScss.entryTime
                                    }, React.createElement("time", undefined, Util.s("18:00 - 22:00"))), React.createElement("dd", {
                                      className: ScheduleModuleScss.entryDescription
                                    }, Util.s("Get together at a local wine tavern (Heuriger)")))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var $$default = ReasonReact.wrapReasonForJs(component, (function (jsProps) {
        return make(jsProps.children);
      }));

var Link = 0;

var breakRow = miscRow;

exports.Link = Link;
exports.talkSlug = talkSlug;
exports.component = component;
exports.toTimeStr = toTimeStr;
exports.toDurationStr = toDurationStr;
exports.miscRow = miscRow;
exports.breakRow = breakRow;
exports.talkRow = talkRow;
exports.workshopRow = workshopRow;
exports.openEndRow = openEndRow;
exports.createRow = createRow;
exports.make = make;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/pages/schedule.js